import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './CardWithLink.css';
import {NavLink, Badge} from 'reactstrap';
import {Link} from 'react-router-dom';
import IconContainer from '../../iconContainer/IconContainer';
import _ from 'lodash';

class CardWithLink extends Component {
    render() {
        if (this.props.hidden) {
            return null;
        }

        switch (this.props.tag) {
            case 'a':
                return (
                    <NavLink className={"card-with-link-container " + (this.props.className || "")}
                             href={this.props.to}
                             target="_blank">
                        {this.renderCardContent()}
                    </NavLink>
                );
            case 'Link':
                return (
                    <NavLink className={"card-with-link-container " + (this.props.className || "")}
                             tag={Link}
                             to={this.props.to}>
                        {this.renderCardContent()}
                    </NavLink>
                );
            default:
                return null;
        }
    }

    renderCardContent = () => {
        return ([
            <div className="card-with-link-icon-container" key='icon'>
                <IconContainer className="card-with-link-icon" icon={this.props.icon}/>
            </div>,
            <div className="card-with-link-info-container" key='info'>
                <div className="card-with-link-label">{this.props.title}</div>
                <div className="card-with-link-text">{this.props.text || ''}</div>
            </div>,
            this.renderNotification()
        ])
    };

    renderNotification = () => {
        if (_.isNil(this.props.notification) || _.isNil(this.props.notification.data) || this.props.notification.data === 0) {
            return null;
        }

        let titleText = _.get(this.props.translation, 'notifications.' + this.props.notification.type);
        return (
            <div className="notifications-container"
                 key='notification'
                 title={titleText ? titleText.replace('{number}', this.props.notification.data) : null}>
                <h5><Badge pill>{this.props.notification.data}</Badge></h5>
            </div>
        )
    }
}

CardWithLink.propTypes = {
    className: PropTypes.string,
    to: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    text: PropTypes.string,
    notification: PropTypes.object,
    translation: PropTypes.object,
    tag: PropTypes.string.isRequired,
    hidden: PropTypes.bool
};

export default CardWithLink;



// WEBPACK FOOTER //
// ./src/components/commonComponents/homePage/cardWithLink/CardWithLink.js